import { Ajax } from "./infra";
import { ZendeskArticle } from "../model";
import { Configs } from "../logic";
/**
 * API for Zendesk
 */
export class HelpCenter {
  public static $inject = ["AjaxNg1"];
  constructor(private ajax: Ajax) { }

  /**
   * Gets list of articles
   * @returns List of articles
   */
  public getArticles(): Promise<ZendeskArticle[]> {
    return this.ajax.getJSON(`${Configs.current.reportServer}/articles`);
  }

  /**
   * Gets single article by id
   * @param id article id
   * @returns article as json
   */
  public getArticle(id: string): Promise<ZendeskArticle> {
    return this.ajax.getJSON(`${Configs.current.reportServer}/articles/${id}`);
  }

  /**
   * Gets single article by id
   * @param id article id
   * @returns article as text
   */
  public getArticleHTML(id: string): Promise<string> {
    return this.ajax.getHTML(`${Configs.current.reportServer}/articles/${id}/html`);
  }

  /**
   * Gets list of articles
   * @returns List of articles
   */
  public getCategoryArticles(id: string): Promise<ZendeskArticle[]> {
    return this.ajax.getJSON(`${Configs.current.reportServer}/articles/category/${id}`);
  }
}